import {ExclamationCircleOutlined} from "@ant-design/icons";
import {TaskDueType} from "../../api/Constants";

export const TaskDueIndicator = ({alert, props}) => {
    // red
    let tagColor = "#108ee9";
    switch (alert) {
        case TaskDueType.OverDue:
            tagColor = "#f55442"
            break;
        case TaskDueType.Today:
            tagColor = "#fa9f02";
            break;
        default:
        case TaskDueType.Soon:
            tagColor = "#108ee9";
            break;
    }

    return <ExclamationCircleOutlined style={{color: tagColor}}/>
}